'use strict';

module.exports = {
  isIe9: require('@braintree/browser-detection/is-ie9'),
  isIos: require('@braintree/browser-detection/is-ios'),
  isIosWebview: require('@braintree/browser-detection/is-ios-webview')
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/~/braintree-web/hosted-fields/shared/browser-detection.js
// module id = 801
// module chunks = 0